import { SalesOrdersService } from "./../../../services/documents/SalesOrdersService";
import { ICreateSalesOrdersDto } from "../../../components/Pages/Documents/SalesOrders/dtos/ICreateSalesOrdersDto";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { SalesOrdersDetail } from "../../../components/Pages/Documents/SalesOrders/components/SalesOrdersDetail";
import { NFLookupSalesOrders } from "../../../components/Shared/NewForms/NFLookupSalesOrders";
import { VatTypeEnum } from "../../../enums/VatTypeEnum";
import SalesOrdersList from "src/components/Pages/Documents/SalesOrders/components/SalesOrdersList";

export const SalesOrders: IAppEntity = {
  entityType: "document",
  title: "Sales Orders",
  pluralTitle: "Sales Orders",
  apiUrl: "SalesOrders",
  apiEnum: ReferenceTypes.DocumentSalesOrder,
  getDetailView: (id?: string) => {
    return React.createElement(SalesOrdersDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),

  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SalesOrdersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSalesOrders, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new SalesOrdersService("SalesOrders"),
  getEmptyModel: () => {
    const model: ICreateSalesOrdersDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,

      documentDate: new Date(),
      createdDate: new Date(),
      approvalDate: new Date(),
      vatType: VatTypeEnum.Vat18,
      // products: [],
      // services: [],
      // paymentOffsets: []
    };
    return model;
  }
};
